// Polish Phase 5 (SCREEN-02) — §19.2 loading spinner.
//
// A small Sun-Yellow rune-circle that rotates in 1.4s with a Plum trailing dot
// (recipe `.rune-spinner` in pieces.css). Presentational only — the spinning
// element is aria-hidden; callers own the accessible "loading" status text
// (role="status" + a localized label) so screen readers announce the state
// regardless of motion preference.

import type { CSSProperties, JSX } from 'react'

export function Spinner({ style }: { style?: CSSProperties }): JSX.Element {
  return <div className="rune-spinner" aria-hidden="true" style={style} />
}
